import {
    MoreMenuContainer,
    StyledCodeNumber,
    StyledPhoto,
    StyledTextLabel,
} from "./Subject.styles";

import HStack from "shared/components/layout/stack/HStack";
import More from "features/allocations/components/grid/employee/More";
import PropTypes from "prop-types";
import React from "react";
import Text from "shared/components/data-display/text/Text";
import VStack from "shared/components/layout/stack/VStack";

const Subject = ({
    photoUrl = "",
    user,
    profileLink,
    subjectName,
    codeNumber,
    label,
    showPhoto = true,
    isMoreIcon = true,
}) => {
    return (
        <VStack>
            {showPhoto && <StyledPhoto url={photoUrl} alt={subjectName} />}
            <VStack spacing="Zero_5">
                <HStack
                    spacing="Zero_25"
                    align="flex-start"
                    justify="space-between"
                >
                    {subjectName && (
                        <Text variant="Headline_2" color="Black">
                            {subjectName}
                        </Text>
                    )}
                    {isMoreIcon && (
                        <MoreMenuContainer>
                            <More
                                visible
                                disableProfile
                                employee={user}
                                skillSearchLink={profileLink}
                                direction="left"
                                portal={true}
                            />
                        </MoreMenuContainer>
                    )}
                </HStack>
                {codeNumber && (
                    <StyledCodeNumber
                        variant="Descriptive_1_1"
                        color="Gray_2"
                    >
                        {codeNumber}
                    </StyledCodeNumber>
                )}
                {label && (
                    <StyledTextLabel variant="Descriptive_2_2" color="Gray_2">
                        {label}
                    </StyledTextLabel>
                )}
            </VStack>
        </VStack>
    );
};

Subject.propTypes = {
    photoUrl: PropTypes.string,
    user: PropTypes.object,
    profileLink: PropTypes.string,
    subjectName: PropTypes.string,
    codeNumber: PropTypes.string,
    label: PropTypes.string,
    showPhoto: PropTypes.bool,
    isMoreIcon: PropTypes.bool,
};

export default Subject;
